import moment from "moment";

export default function ProcessingPumps({ processingPumps }) {
	return (
		<div style={{ display: "flex", flexDirection: "column", flex: "1 1 20%" }}>
			<h3>Running Now</h3>
			<div
				style={{
					overflowY: "auto",
					display: "flex",
					flexWrap: "wrap",
					gap: "10px",
				}}
			>
				{processingPumps &&
					processingPumps.map(
						({ id, symbol, plotResultPath, createdAt, finishDate }) => (
							<div
								key={id}
								style={{
									width: "200px",
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									padding: "2px",
									border: "1px solid black",
									borderRadius: "4px",
									marginBottom: "10px",
								}}
							>
								<span
									style={{
										width: "90%",
										textAlign: "center",
										// color: "white",
										// backgroundColor: "rgba(0, 0, 0, 0.5)",
										padding: "2px",
									}}
								>
									Launched: {moment(+createdAt).format("DD MMM HH:mm")}
								</span>
								<span
									style={{
										width: "90%",
										textAlign: "center",
										// color: "white",
										// backgroundColor: "rgba(0, 0, 0, 0.5)",
										padding: "2px",
									}}
								>
									Last scope: {moment(finishDate).format("DD MMM")}
								</span>
								<span
									style={{
										width: "90%",
										textAlign: "center",
										// color: "white",
										// backgroundColor: "rgba(0, 0, 0, 0.5)",
										padding: "2px",
									}}
								>
									Coin: {symbol}
								</span>
							</div>
						)
					)}
			</div>
		</div>
	);
}
